import { CarrierAccount } from "@redotech/redo-fulfillment-rate-common/carrier-account";
import * as z from "zod";
import { null as zNull } from "zod";
export const getCarrierAccounts = {
  name: "getCarrierAccounts" as const,
  input: zNull(),
  output: z.object({
    merchantCarrierAccounts: z.array(CarrierAccount),
    customerCarrierAccounts: z.array(CarrierAccount),
    redoChildCarrierAccounts: z.array(CarrierAccount),
    // Per-team Sendcloud BYOA flag (default OFF). Drives whether the merchant
    // UI offers Sendcloud as an addable carrier.
    sendcloudByoaEnabled: z.boolean(),
    // Per-team flag (default OFF) for direct Amazon Shipping connect and Reconnect.
    amazonShippingDirectEnabled: z.boolean(),
    // Per-team flag (default OFF) for direct GOFO connect and Reconnect.
    gofoDirectEnabled: z.boolean(),
    // Merchant accounts whose latest connection test failed; untested accounts are not listed.
    unverifiedCarrierAccountIds: z.array(z.string()),
  }),
};
